import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/data-model.js';
import { cloneMap, isSameMap, mapToData } from '../dto/data-model-utils.js';

export interface Permission {
  uniqueId: string;
}

export interface PermissionMatrix {
  has(permission: Permission): boolean;
}

export class GenericPermissionMatrix extends DataModel implements PermissionMatrix {
  static readonly TYPE_ID: string = '22ce46893a08497b89aa141301598062';

  constructor(private readonly permissions: Map<string, boolean>) {
    super();
  }

  get $typeId(): string {
    return GenericPermissionMatrix.TYPE_ID;
  }

  has(permission: Permission): boolean {
    return this.permissions.get(permission.uniqueId) === true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): GenericPermissionMatrix {
    return new GenericPermissionMatrix(
        MapUtils.getMap(map, 'permissions', (k, v) => ({ key: k, value: v as boolean })),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'permissions': mapToData(this.permissions, (k, v) => ({ key: k, value: v })),
    };
  }

  clone(): this {
    return new GenericPermissionMatrix(
        cloneMap(this.permissions),
    ) as this;
  }

  isSame(other: GenericPermissionMatrix): boolean {
    if(this === other) {
      return true;
    }

    return isSameMap(other.permissions, this.permissions);
  }
}

export class GenericPermissionMatrixBuilder extends DataModelBuilder<GenericPermissionMatrix> {
  build(context: SerializationContext, map: SerializedData): GenericPermissionMatrix {
    return GenericPermissionMatrix.fromMap(context, map);
  }
}
